/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowWeekendRetreatTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowWeekendRetreat,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Retreat and Relax!",
    "Weekend Getaway Awaits!",
    "Unwind Together!",
  ],
  title: "Weekend Retreat",
  description: "Organize a relaxing weekend retreat.",
  longDescription:
    "Gather your friends for a rejuvenating weekend retreat! Choose a date, decide on activities to enjoy, and plan meals for the retreat!",
  emoji: "🏕",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Travel,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Weekend Retreat",
          emoji: "🏕",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we have the weekend retreat?",
          emoji: "📅",
          completeAction: {
            question: "Decide on activities for the retreat?",
            description:
              "What activities should we include during the retreat?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What activities should we consider?",
                emoji: "🌲",
                completeAction: {
                  question: "Decide on meals?",
                  description: "What meals should we plan for the weekend?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What meals should we bring?",
                      emoji: "🍽",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let’s Enjoy the Retreat!",
    outroDescription:
      "Your weekend retreat plans are set! Enjoy the relaxation!",
  },
};
